import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
import { createLogger } from 'utility/datadog-util';
export default class PatientQueueDuplicatesTrack extends AbstractTrack {
    /* @ngInject */
    constructor($injector) {
        super($injector);
        this.$injector = $injector;
        this.eventNameSegment = 'Patient Queue Contains Duplicates';
        const institution = this.stateWatcher.getInstitutionInfo();
        const userInfo = this.stateWatcher.getUserInfo();
        const context = {
            anonymous_id: userInfo.userId,
            clinic_domain: institution.domain,
            clinic_id: institution.clinicId,
            plan_type: userInfo.planType,
            user_id: userInfo.userId,
            user_type: userInfo.userType,
        };
        this.logger = createLogger('patientQueue', { context, level: 'info' });
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.PATIENT_QUEUE.DUPLICATES, ($e, context) => {
            this.logger?.warn("Duplicate patients in patient queue, they've been filtered out so the provider wont see this", {
                ...context,
            });
            this.trackSegment({
                ...context,
                duplicates: JSON.stringify(context.duplicates),
            }, true);
        });
    }
}
